module.exports = __webpack_public_path__ + "static/media/upside_logo.d8678808.png";